module.exports = __webpack_public_path__ + "static/media/user.25e82cdb.svg";